import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {NgbActiveModal, NgbInputDatepicker} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {Subscription} from "rxjs";
import {ToastService} from "../../../../services/toaster.service";
import {BaseComponent} from "../../../base/base.component";
import {CommentContract} from "../../../../models/contract.model";
import {ReleasePlanApiService} from "../../../../services/api/release-plan-api.service";


@Component({
  selector: 'app-contract-comment-modal',
  templateUrl: './planning-region-contract-comment-modal.component.html',
  styleUrls: ['./planning-region-contract-comment-modal.component.scss'],
  standalone: true,
  imports: [TranslateModule, FormsModule, NgIf, NgForOf, NgbInputDatepicker, DatePipe]
})
export class ContractCommentModalComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input() comments: CommentContract[] = [];

  private subscriptions: Subscription = new Subscription();

  constructor(
    public activeModal: NgbActiveModal,
    private releasePlanApiService: ReleasePlanApiService,
    private toastService: ToastService,
  ) {
    super();
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  closeModal(): void {
    this.activeModal.close();
  }

  updateComment(idWeek: number, comment: string): void {
    this.releasePlanApiService.updateCommentProgWeek(this.cookies, idWeek, comment).subscribe({
      next: (response) => {
        this.toastService.showSuccess('toast.success');
      },
      error: (error) => {
        this.toastService.showDanger('toast.error');
      },
    });
  }
}
